import CouponError from './CouponsError';
class CouponNotBelongToProperty extends CouponError {
    couponId;
    propertyId;
    constructor(couponId, propertyId, options) {
        super('Promotional coupon does not belong to crowdfunding property', options);
        this.couponId = couponId;
        this.propertyId = propertyId;
    }
}
export default CouponNotBelongToProperty;
